export type LocalizedText = Record<string, string>;

export function getLocalized(field: LocalizedText | undefined, locale: string): string {
  if (!field) return '';
  return field[locale] ?? field.en ?? '';
}
